import type { ContinuationListRow } from '@/services/main/continuation/continuationService';
import type { PrintOptionsState, SearchState } from './types';
import { convertWarekiWrap } from '@/utils/wareki';

export const DEFAULT_RATE_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: '1', label: '1割' },
  { value: '2', label: '2割' },
  { value: '3', label: '3割' },
  { value: '10', label: '10割' },
];

export const BUI_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: '1', label: '1術' },
  { value: '2', label: '2術' },
];

/** BD §1.3.4 — R2's replacement for A2's 部位数. */
export const TREATMENT_KIND_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: 'massage', label: 'マッサージ' },
  { value: 'orthomorphia', label: '変形徒手矯正' },
];

export const DEFAULT_INI_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: '1', label: 'ア行' },
  { value: '2', label: 'カ行' },
  { value: '3', label: 'サ行' },
  { value: '4', label: 'タ行' },
  { value: '5', label: 'ナ行' },
  { value: '6', label: 'ハ行' },
  { value: '7', label: 'マ行' },
  { value: '8', label: 'ヤ行' },
  { value: '9', label: 'ラ行' },
  { value: '10', label: 'ワ行' },
];

export const EMPTY_LIST: ContinuationListRow[] = [];

export const INVOICE_PAGE_SIZE = 100;

export const INITIAL_SEARCH: SearchState = {
  search_term_type: 1,
  search_treatment: '',
  search_treatment_yearmonth: '',
  search_treatement_from: '',
  search_treatement_to: '',
  patient_cost_rate: '',
  bui: '',
  treatment_kind: '',
  shoken1: false,
  shoken2: false,
  search_text: 0,
  search_patient_id: '',
  search_patient_name: '',
  ini: '',
  sort: 0,
};

export const INITIAL_PRINT_OPTIONS: PrintOptionsState = {
  print_visit_clinic_invoice: false,
  print_visit_clinic_invoice_free_medical: false,
  print_monthly: false,
  print_visit_clinic_invoice_100: false,
  print_visit_clinic_invoice_free_medical_100: false,
  print_monthly_100: false,
  option_1: true,
  option_2: true,
  option_3: false,
  option_4: false,
  option_5: true,
  option_7: false,
  option_8: false,
  option_11: true,
  option_date: '',
};

// Initial print options with the date input pre-filled to today (wareki),
// matching 受診者番号を表示 / 日付を表示 defaulting ON.
export const getInitialPrintOptions = (): PrintOptionsState => {
  const today = new Date();
  const y = String(today.getFullYear());
  const m = String(today.getMonth() + 1).padStart(2, '0');
  const d = String(today.getDate()).padStart(2, '0');
  return { ...INITIAL_PRINT_OPTIONS, option_date: convertWarekiWrap(`${y}/${m}/${d}`) };
};
